import { render, staticRenderFns } from "./BookingPresetNotificationForm.vue?vue&type=template&id=653680b5&scoped=true&"
import script from "./BookingPresetNotificationForm.vue?vue&type=script&lang=js&"
export * from "./BookingPresetNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingPresetNotificationForm.vue?vue&type=style&index=0&id=653680b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653680b5",
  null
  
)

export default component.exports